import React, { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { ModalDocumento } from "../../components/Otros/ModalDocumento";
import { cargarPrecalificaciones } from "../../utils/Datos";

export const ResumenEvaluaciones = ({ id_participant = null }) => {
  const [datosPrecalificaciones, setdatosPrecalificaciones] = useState(null);

  useEffect(() => {
    cargarPrecalificaciones(id_participant).then((precalificaciones) => {
      if (precalificaciones !== null) {
        //
        setdatosPrecalificaciones(precalificaciones);
      }
    });
  }, []);

  return (
    <div className="row mb-5">
      {datosPrecalificaciones !== null ? (
        datosPrecalificaciones.map((d, index) => {
          console.log("Datos");
          console.log(d);
          return (
            <div className="col-xl-4 col-sm-12" key={`div_${index}`}>
              <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6 mb-8 p-6">
                <div className="d-flex flex-stack flex-grow-1">
                  <div className="fw-bold">
                    <h4 className="text-gray-900 fw-bolder">{d.name}</h4>
                    <div className="fs-6 text-gray-700">
                      ({d.starDate} - {d.endDate})
                    </div>
                  

                    {
                      d.file!=null ?
                      <>
                        <button
                          className="btn btn-sm btn-primary mt-3"
                          data-bs-toggle="modal"
                          data-bs-target={`#modal22${index}`}
                        >
                          Ver documento
                        </button>
                          <ModalDocumento
                            id={`modal22${index}`}
                            documentoByte={d.file.contentByte ?? ""}
                          />
                      </>
                      
                      : <>
                      <br></br>
                      <small class="text-muted mt-5"><i className="fas fa-exclamation-triangle mr-3"></i> No hay documentos para mostrar.</small>
                      </>
                    }
                    
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};
